export var sexualityMap = {
  1: 'Heterosexuell',
  2: 'Bisexuell',
  3: 'Homosexuell'
};